import { render } from "./SvgIcon.vue?vue&type=template&id=1b343748&scoped=true"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"

import "./SvgIcon.vue?vue&type=style&index=0&id=1b343748&scoped=true&lang=css"

import exportComponent from "/Users/liuli/Desktop/istory/vue3-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b343748"]])

export default __exports__